export default {"src":"/_next/static/media/logo.f384205d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};